import { toast } from 'src/lib/toast';

export const copyIntoClipBoard = (value: string): void => {
  navigator.clipboard.writeText(value);
  toast.success('Copied to clipboard');
};
